
import { ApiManager } from "../api/ApiManager";
import ITreatmentPlanTemplateResponseObj, { ISuggestionType, ITreatmentPlanTemplateSaveObj } from "../models/ITreatmentPlanTemplateResponse";
import { RECOMMENDATIONS_SECTIONS } from "../utils/AppConstants";
import { IConstituentTemplate } from "../models/PdfTemplatesModels";
import { INewConfigData } from "../models/patients/IEHRSavePatientMedicalProfile";
import { EHRRequestMapper } from "../api/EHRRequestMapper";
import { IConfigBasedPrescription } from "../models/patients/IConfigBasedPrescription";
import { STORE_TEMPLATES_IDS_NAMES_MAP } from "./ActionTypes";
import { IRecomTemplate, IRecomTemplateWithPrescriptionData } from "../models/IRecoTemplates";
import { OngoingConsultationActions } from "./OngoingConsultationActions";

export class TreatmentPlanActions {
    static fetchAllTreatmentPlanTemplates = (doctorId: number, dispatch: any): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
        return ApiManager.getEHRApis().getAllTreatmentPlanTemplates(doctorId).then((response) => {
            dispatch(TreatmentPlanActions.storeTemplateIdNamesMapping(response || []));
            return response;
        });
    };

    static storeTemplateIdNamesMapping = function (templatesArray: any[]) {
        return {
            type: STORE_TEMPLATES_IDS_NAMES_MAP,
            templatesArray
        }
    }

    static fetchTreatmentPlansByName = (doctorId: number, query: string): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
        return ApiManager.getEHRApis().getTreatmentPlanTemplatesByName(doctorId, query)
    };

    static deleteTreatmentPlan = (templateId: string): Promise<any> => {
        return ApiManager.getEHRApis().deleteTreatmentPlan(templateId)
    }

    static fetchTreatmentPlansById = (templateId: string): Promise<ITreatmentPlanTemplateResponseObj> => {
        return ApiManager.getEHRApis().getTreatmentPlanTemplatesById(templateId)
    };

    static fetchTreatmentPlanDetails = async (doctorType: string): Promise<any> => {
        let details;
        await ApiManager.getOrionApis().getTreatmentPlanDetails(doctorType).then((response: any) => {
            details = response
        });
        return details
    }

    static fetchTreatmentPlanSuggestions = (doctorId: number, diagnosis: Array<string>): Promise<Array<ITreatmentPlanTemplateResponseObj>> => {
        return ApiManager.getEHRApis().getTreatmentPlanTemplates(doctorId, diagnosis)
    }

    static fetchSuggestionsForSubSections = (doctorId: number, doctorType: string): Promise<ISuggestionType> => {
        return ApiManager.getEHRApis().getSubSectionsRecommendations(doctorId, "doctor", doctorType, RECOMMENDATIONS_SECTIONS[doctorType] || [])
    }

    static saveTreatmentPlan = (template: ITreatmentPlanTemplateSaveObj): Promise<any> => {
        return ApiManager.getEHRApis().saveTreatmentPlanTemplate(template)
    }

    static fetchConsultationPdfTemplates = (doctorId: number, centerId: number, subServiceType: string): Promise<IConstituentTemplate> => {
        return ApiManager.getOllivanderServiceApis().fetchTemplates(
            doctorId,
            centerId,
            subServiceType
        )
    }

    static fetchConsultationDetails = async (patientId: string, appointmentId: string, subServiceType: string): Promise<IConfigBasedPrescription> => {
        let medicalProfile = {} as IConfigBasedPrescription
        await ApiManager.getOrionApis().fetchPastConsultationDataForPatient(appointmentId, subServiceType, patientId)
            .then((response: { caseSummary: any, consultationData: INewConfigData }) => {
                medicalProfile = EHRRequestMapper.getConfigBasePrescriptionFromEHRGerPrescriptionResponse(response.consultationData)
            });
        return medicalProfile;
    }

    static fetchRecomTemplates = (doctorId: number, count: number, doctorType: string): Promise<IRecomTemplateWithPrescriptionData> => {
        return new Promise((resolve, reject) => {
            ApiManager.getAlbusApis().fetchRecomTemplates(doctorId, count)
                .then(res => {
                    TreatmentPlanActions.fetchPrescriptionForRecoTemplates(res, doctorType)
                        .then(resolve)
                        .catch(console.log);
                })
        })
    }

    static fetchPrescriptionForRecoTemplates = (recoTemplates: IRecomTemplate, doctorType: string): Promise<IRecomTemplateWithPrescriptionData> => {
        return new Promise((resolve, reject) => {
            if (recoTemplates && recoTemplates.appointment && recoTemplates.appointment.length) {
                let allPrescriptioForRecoTemplates: Promise<any>[] = recoTemplates.appointment.map(({ referenceId, patientId }) =>
                    OngoingConsultationActions.getPrescriptionByReferenceId(patientId, referenceId, doctorType)
                );
                Promise.all(allPrescriptioForRecoTemplates)
                    .then(res => {
                        resolve({
                            ...recoTemplates,
                            prescriptions: EHRRequestMapper.convertPastPrescriptionsToTemplateData(res.map(({ newConfigData }) => newConfigData))
                        });
                    })
            } else {
                reject("NO_RECO_RELATED_PRESCRIPTION");
            }
        })

    }
}